import { useEffect } from "react";
import { Link } from "react-router-dom";
import { USFlag } from "@/components/USFlag";

export const LegalLayout = ({ title, effective, updated, children }) => {
  useEffect(() => {
    document.title = `${title} — Dane Lomax, LLC`;
    window.scrollTo(0, 0);
  }, [title]);
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <main className="max-w-[720px] mx-auto px-6 sm:px-8 py-16 md:py-24">
        <Link to="/" data-testid="legal-home-link"
          className="text-[16px] font-medium text-[#D6D6D6] hover:text-white transition-colors duration-300">
          ← danelomax.com
        </Link>
        <h1 className="font-display text-[32px] md:text-[40px] leading-[1.12] text-white mt-12">{title}</h1>
        <div className="mt-6 space-y-1">
          <p className="text-[16px] font-normal text-[#D6D6D6]">Effective date: {effective}</p>
          <p className="text-[16px] font-normal text-[#D6D6D6]">Last updated: {updated}</p>
        </div>
        <div className="mt-14 space-y-12 text-[17px] font-normal text-[#D6D6D6] leading-[1.7] [&_h2]:font-display [&_h2]:text-white [&_h2]:text-[22px] [&_h2]:leading-[1.3] [&_h2]:mb-5 [&_p]:mb-4 [&_ul]:list-none [&_ul]:space-y-3 [&_li]:pl-4 [&_li]:border-l [&_li]:border-[#2E2E2E] [&_strong]:text-white [&_strong]:font-bold [&_a]:text-[#FF5C5C] [&_a]:underline [&_a]:underline-offset-4 [&_a]:decoration-1">
          {children}
        </div>
        <div className="mt-20 border-t border-[#2E2E2E] pt-8">
          <p className="text-[16px] font-normal text-[#D6D6D6]">
            © {new Date().getFullYear()} Dane Lomax, LLC · <Link to="/" className="text-[#D6D6D6] hover:text-white underline underline-offset-4 decoration-1">danelomax.com</Link>
          </p>
          <p className="mt-5 flex items-center gap-2.5 text-[16px] font-medium text-white">
            <USFlag width={26} height={16} /> Proudly Made in the USA
          </p>
        </div>
      </main>
    </div>
  );
};
